import React, { useState, useEffect } from 'react';
import styles from './SmoothProgressBar.module.css';

interface SmoothProgressBarProps {
  /**
   * The total duration in minutes for the progress bar to fill.
   */
  durationMinutes: number;
}

const SmoothProgressBar: React.FC<SmoothProgressBarProps> = ({ durationMinutes }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const durationMilliseconds = durationMinutes * 60 * 1000;
    let startTime: number;
    let animationFrameId: number;

    const step = (timestamp: number) => {
      if (!startTime) {
        startTime = timestamp;
      }

      const elapsedTime = timestamp - startTime;
      const currentProgress = Math.min(100, (elapsedTime / durationMilliseconds) * 100);

      setProgress(currentProgress);

      if (elapsedTime < durationMilliseconds) {
        animationFrameId = requestAnimationFrame(step);
      }
    };

    animationFrameId = requestAnimationFrame(step);

    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, [durationMinutes]);

  return (
    <div className={styles.progressBarTrack}>
      <div className={styles.progressBarFill} style={{ width: `${progress}%` }} data-testid="progress-bar-fill" />
    </div>
  );
};

export default SmoothProgressBar;
